// @flow

export function transformOldTrovitUrlPathToQuery(urlPath: string) {
  let formattedUrlPath = urlPath.replace('index.php/', '');
  formattedUrlPath = formattedUrlPath.replace(/&|\?/g, '/');
  formattedUrlPath = formattedUrlPath.replace(/=/g, '.');

  const queryParsed = formattedUrlPath.split('/').reduce((params, param) => {
    const paramSplitted = param.replace(/\+/g, ' ').split('.');
    const key = paramSplitted[0];
    let value = paramSplitted[1];

    value = value === undefined ? null : decodeURIComponent(value);

    if (value) {
      return { ...params, ...{ [key]: value } };
    }

    return params;
  }, {});

  return queryParsed;
}



// WEBPACK FOOTER //
// ./app/utils/oldTrovit/url.js